import '../styles/UXSurveyStyle.css';
import { useEffect, useState } from 'react';
import { useTypedSelector, useActions } from '../../hooks';
import { SurveyFeedbackChoice } from '../../models/api';
import { MdCancel } from 'react-icons/md';
import { apiErrorHandler, apiGET, apiPOST } from '../../restAPI';
import {
  SurveyRequestGET,
  SurveyRequestPOST,
  SurveyResponseGET,
  SurveyResponsePOST,
} from '../../models/cruds';
import { APIResponseStatusType } from '../../models/types';
import { Dropdown } from 'react-bootstrap';
import { FormButton } from '../common';

const BAD_OPTION = 1;
const AVERAGE_OPTION = 2;
const OTHER_FEEDBACK_CHOICE_PLACEHOLDER = '¿Quieres contarnos porque?';
const THANK_YOU_MESSAGE = '¡Gracias por tu feedback!';
const FEEDBACK_OTHER_OPTION = 4;
const UXSurvey: React.FC = () => {
  const [surveyComments, setSurveyComments] = useState('');
  const [showSurvey, setShowSurvey] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState('');
  const surveyEmail = useTypedSelector(({ uxSurvey }) => {
    return uxSurvey.surveyEmail;
  });
  const survey = useTypedSelector(({ uxSurvey }) => {
    return uxSurvey.survey;
  });
  const fetchingSurvey = useTypedSelector(({ uxSurvey }) => {
    return uxSurvey.fetchingSurvey;
  });
  const answeredSurvey = useTypedSelector(({ uxSurvey }) => {
    return uxSurvey.answeredSurvey;
  });
  const surveyChoice = useTypedSelector(({ uxSurvey }) => {
    return uxSurvey.surveyChoice;
  });
  const surveyFeedbackChoice = useTypedSelector(({ uxSurvey }) => {
    return uxSurvey.surveyFeedbackChoice;
  });
  const {
    updateSurvey,
    updateFetchingSurvey,
    updateAnsweredSurvey,
    updateSurveyChoice,
    updateSurveyFeedbackChoice,
  } = useActions();
  useEffect(() => {
    if (feedbackMessage !== '') {
      setTimeout(() => {
        setFeedbackMessage('');
        setShowSurvey(false);
      }, 2500);
    }
  }, [feedbackMessage]);
  useEffect(() => {
    const getSurvey = async () => {
      updateFetchingSurvey(true);
      let request = new SurveyRequestGET();
      let response: SurveyResponseGET = await apiGET(
        request.buildURL(surveyEmail),
        request.generateConfig()
      );
      let feedbackMsg = '';
      console.log(response);
      try {
        if (response.status === APIResponseStatusType.SUCCESS) {
          if (response.data) {
            updateSurvey(response.data);
            updateFetchingSurvey(false);
            if (response.data.showSurvey) {
              setShowSurvey(true);
            }
            return;
          } else {
          }
        } else {
          feedbackMsg = apiErrorHandler(response);
          console.error('Zip response: ', feedbackMsg);
        }
      } catch (err: any) {
        console.error('Catching: ', err);
        feedbackMsg = err.toString();
      }
    };
    if (!survey && surveyEmail !== '' && !fetchingSurvey && !answeredSurvey) {
      getSurvey();
    }
  }, [
    survey,
    surveyEmail,
    fetchingSurvey,
    answeredSurvey,
    updateSurvey,
    updateFetchingSurvey,
  ]);
  const postSurvey = async () => {
    setFeedbackMessage(THANK_YOU_MESSAGE);
    updateAnsweredSurvey(true);
    let request = new SurveyRequestPOST();
    let response: SurveyResponsePOST = await apiPOST(
      request.buildURL(surveyEmail),
      request.generateContent(
        surveyEmail,
        surveyComments,
        surveyChoice,
        surveyFeedbackChoice
      ),
      request.generateConfig()
    );
    let feedbackMsg = '';
    console.log(response);
    try {
      if (response.status === APIResponseStatusType.SUCCESS) {
        if (response.data) {
          updateFetchingSurvey(false);
          return;
        } else {
        }
      } else {
        feedbackMsg = apiErrorHandler(response);
        console.error('Zip response: ', feedbackMsg);
      }
    } catch (err: any) {
      console.error('Catching: ', err);
      feedbackMsg = err.toString();
    }
  };
  const renderOtherFeedback = () => {
    if (surveyFeedbackChoice === FEEDBACK_OTHER_OPTION) {
      return (
        <textarea
          className="ux-survey-feedback-other"
          onChange={(e) => setSurveyComments(e.target.value)}
          maxLength={500}
        ></textarea>
      );
    }
    return null;
  };
  const renderSelectedFeedbackOption = () => {
    console.log(
      survey?.feedbackChoices?.find(
        (item) => parseInt(item.choice) === surveyFeedbackChoice
      )
    );
    console.log(surveyFeedbackChoice);
    return (
      survey?.feedbackChoices?.find(
        (item) => parseInt(item.id) === surveyFeedbackChoice
      )?.choice ?? OTHER_FEEDBACK_CHOICE_PLACEHOLDER
    );
  };
  const renderFeedbackChoices = () => {
    if (survey?.feedbackChoices) {
      let sortedArray = [...survey?.feedbackChoices]?.sort(
        (a, b) => a.order - b.order
      );
      if (surveyChoice === BAD_OPTION || surveyChoice === AVERAGE_OPTION) {
        return (
          <div className="ux-survey-feedback-container">
            <Dropdown className={`default-dropdown nomargin`}>
              <Dropdown.Toggle
                className="default-dropdown-toggle ux-survey-toggle"
                id="dropdown-basic"
              >
                {renderSelectedFeedbackOption()}
              </Dropdown.Toggle>
              <Dropdown.Menu
                data-cy="units-dropdown-menu"
                className="default-dropdown-menu"
              >
                {sortedArray.map((option: SurveyFeedbackChoice, id: number) => {
                  return (
                    <Dropdown.Item
                      key={option.id}
                      data-cy="units-dropdown-item"
                      className="default-dropdown-item"
                      onClick={() => {
                        updateSurveyFeedbackChoice(parseInt(option.id));
                      }}
                    >
                      {option.choice}
                    </Dropdown.Item>
                  );
                })}
              </Dropdown.Menu>
            </Dropdown>
            {renderOtherFeedback()}
          </div>
        );
      }
    }
    return null;
  };
  const getSelectedChoiceClass = (option: number) => {
    if (option === surveyChoice) {
      return 'selected';
    }
  };
  const renderOkButton = () => {
    if (surveyChoice !== 0) {
      return (
        <FormButton
          extraClassName="ux-survey-ok-button"
          content={'Ok'}
          disabled={false}
          onSubmit={() => {
            postSurvey();
          }}
        />
      );
    }
  };
  const renderChoices = () => {
    if (survey?.choices) {
      let sortedArray = [...survey?.choices]?.sort((a, b) => a.order - b.order);
      return (
        <div className="ux-survey-options-container">
          <div className="ux-survey-buttons-container">
            {sortedArray?.map((choice) => {
              return (
                <button
                  key={choice.id}
                  className={`ux-survey-feedback-choice ${getSelectedChoiceClass(
                    parseInt(choice.id)
                  )}`}
                  onClick={() => {
                    updateSurveyChoice(parseInt(choice.id));
                  }}
                >
                  {choice.choice}
                </button>
              );
            })}
          </div>
          <div className="ux-survey-feedback-container">
            {renderFeedbackChoices()}
          </div>
          <div className="ux-survey-ok-container">{renderOkButton()}</div>
        </div>
      );
    }
  };
  const getShowSurvey = () => {
    if (showSurvey) {
      return 'show';
    }
    return '';
  };
  const renderContent = () => {
    if (feedbackMessage !== '') {
      return <p className="ux-survey-thank-you">{THANK_YOU_MESSAGE}</p>;
    }
    return (
      <>
        <div className="ux-survey-title-container">
          <p className="ux-survey-title">
            Ayúdanos a mejorar, ¿Qué % de tus recibos procesas con Batu?
          </p>
          <MdCancel
            className="ux-survey-close-icon"
            onClick={() => {
              updateAnsweredSurvey(true);
              setShowSurvey(false);
            }}
          />
        </div>
        {renderChoices()}
      </>
    );
  };
  return (
    <div className={`ux-survey-container ${getShowSurvey()}`}>
      {renderContent()}
    </div>
  );
};
export { UXSurvey };
